export default "__VITE_ASSET__xsmK7br6__"